import React, { useMemo } from "react";
import { Text } from "@bookingcom/bui-react";
import { useAtolController } from "./useAtol.controller.js";
import useATOL from "../../../../../hooks/useATOL.js";
import useRouteName from "../../../../../hooks/useRouteName.js";
import { useSelector } from "react-redux";
import { getOrder } from "../../../../../store/order/selectors.js";
export function Atol() {
    const { isATolProtectedCheckOut } = useATOL();
    const routeName = useRouteName();
    const order = useSelector(getOrder);
    const isPbOrderDetails = useMemo(() => routeName === "pb-order-details", [routeName]);
    const orderStatus = useMemo(() => order?.orderStatus, [order]);
    const atolProtection = useMemo(() => order?.airOrder?.atolProtection, [order]);
    const isProtectedCheckOut = useMemo(() => isATolProtectedCheckOut(), [isATolProtectedCheckOut]);
    const { text } = useAtolController({ isProtectedCheckOut, atolProtection, orderStatus, isPbOrderDetails });
    if (!text)
        return null;
    return (React.createElement(Text, { variant: "small_1", attributes: { "data-testid": "ATOL_price_breakdown_footer_text" } }, text));
}
